import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import * as fromConfigurationsActions from '../actions/configurations.actions';
import { CONFIGURATIONS_FEATURE_KEY } from '../constants/state-keys';
import { IConfigurationsFeatureState } from '../interfaces/states/configurations-feature-state.interface';

export const SelectFeature = createFeatureSelector<IConfigurationsFeatureState>(CONFIGURATIONS_FEATURE_KEY);

export const adapter: EntityAdapter<string> = createEntityAdapter<string>({
    selectId: selectLocaleId,
});

export const { selectAll } = adapter.getSelectors();

export const SelectAllLocales = createSelector(SelectFeature, selectAll);

export function selectLocaleId(a: string): string {
    return a;
}

const initialState: IConfigurationsFeatureState = adapter.getInitialState({
    businessModelLocales: undefined,
});
export const ConfigurationsReducer = createReducer(
    initialState,
    on(fromConfigurationsActions.configurationsActions.getSupportedLocales, (state) => ({
        ...state,
        error: undefined,
    })),
    on(fromConfigurationsActions.configurationsActions.getSupportedLocalesSuccess, (state, action) => {
        return adapter.setAll(action.payload, { ...state, error: undefined });
    }),
    on(fromConfigurationsActions.configurationsActions.getSupportedLocalesFailed, (state, action) => ({
        ...state,
        error: action.payload,
    })),
);
